export function ConcatePath(...paths: string[]) {
    return paths.reduce((value, item, index) => {
        if (!value.endsWith('/') && !item.startsWith('/') && index) {
            value = value + '/';
        }
        return value + item;
    }, '');
}
//import { NamedEntity, INamedEntity } from '@app/models/offer-management/offer-rule-variable';
//import { ValueType } from '@app/models';


// export function GetNameOfNamedEntity<T extends INamedEntity>(from: T[], id: number) {
//     if (!from) {
//         return undefined;
//     }
//     const obj = from.find(a => a.Id === id);
//     if (!obj) {
//         return undefined;
//     }
//     return obj.Name;
// }
// export function GetNameValueType(from: ValueType[], id: number) {
//     if (!from) {
//         return undefined;
//     }
//     const obj = from.filter(a => a.ValueTypeId === id)[0];
//     if (!obj) {
//         return undefined;
//     }
//     return obj.Name;
// }
// export function toJSONWithRefrance(obj) {
//     const objectCatch = [];
//     return JSON.stringify(obj, (key, value) => {
//         if (!value || Array.isArray(value)) {
//             return value;
//         }
//         switch (typeof value) {
//             case 'object':
//                 const index = objectCatch.indexOf(value);
//                 if (index === -1) {
//                     const $id = `${objectCatch.length}`;
//                     objectCatch.push(value);
//                     return Object.assign({ $id }, value);
//                 } else {
//                     return { $ref: `${index}` };
//                 }
//         }
//         return value;
//     });
// }
// export function parseJSONwithRefrance(str: string, reviver?: (key, value) => any) {
//     const objectCatch = {};
//     const k = JSON.parse(str, (key, value) => {
//         let id;
//         if (value) {
//             id = value.$id;
//             const ref = value.$ref;
//             if (ref) {
//                 return objectCatch[ref];
//             }
//         }
//         if (reviver) {
//             value = reviver(key, value);
//         }
//         if (id) {
//             objectCatch[id] = value;
//         }
//         return value;
//     });
//     return k;
// }

// export class CopyOrReference {
//     constructor(item) {

//     }
//     static CreateIfNotAlready(item: any) {
//         if (item instanceof this) {
//             return item;
//         } else {
//             return new this(item);
//         }
//     }
// }



// WEBPACK FOOTER //
// ./src/app/common/utils.ts